export enum SearchType {
  byName = 1,
  byCode = 0
}
